export default "__VITE_ASSET__bCPveDdq__"